import { userConstants, gbConstants } from "../_constants";
import { userService } from "../_services";
import { alertActions,campaignActions } from "./";
import { history } from "../_helpers";

export const userActions = {
    login,
    logout,
    register,
    campaignSigned,
    updateBalance
};

function login(email, password) {
    return dispatch => {
        dispatch(request({ email }));

        userService.login(email, password).then(
            user => {
                dispatch(success(user));
                history.push(gbConstants.PATH_ROOT);
            },
            error => {
                dispatch(failure(error.message));
                dispatch(alertActions.error(error.message));
            }
        );
    };

    function request(user) {
        return { type: userConstants.LOGIN_REQUEST, user };
    }

    function success(user) {
        return { type: userConstants.LOGIN_SUCCESS, user };
    }

    function failure(error) {
        return { type: userConstants.LOGIN_FAILURE, error };
    }
}

function logout() {
    return dispatch => {
        userService.logout();
        dispatch(campaignActions.checkUpdate(0));
        dispatch(out());
    }
    function out(){
        return { type: userConstants.LOGOUT };
    }
    
}

function register(user) {
    return dispatch => {
        dispatch(request(user));

        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem("user", JSON.stringify(user));

        userService.register(user).then(
            user => {
                // TODO: Wait for server to udpate
                dispatch(success());
                dispatch({ type: userConstants.LOGIN_SUCCESS, user }); // TODO: Remove
                history.push(gbConstants.PATH_VERIFY_ACCOUNT);
            },
            error => {
                if (error.code && error.code === 308) {
                    dispatch(success());
                    history.push(gbConstants.PATH_VERIFY_ACCOUNT);
                } else {
                    dispatch(failure(error.message));
                    dispatch(alertActions.error(error.message));
                }
            }
        );
    };

    function request(user) {
        return { type: userConstants.REGISTER_REQUEST, user };
    }

    function success(user) {
        return { type: userConstants.REGISTER_SUCCESS };
    }

    function failure(error) {
        return { type: userConstants.REGISTER_FAILURE, error };
    }
}

function campaignSigned(campaignId) {
    return dispatch => {
        userService.campaignSigned(campaignId);
        return dispatch({ type: userConstants.CAMPAIGN_SIGNED, campaignId });
    };
}

function updateBalance(balance) {
    return { type: userConstants.UPDATE_ACCOUNT_BALANCE, balance };
}



// WEBPACK FOOTER //
// ./src/_actions/user.actions.js